import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import CategorySection from './components/CategorySection';
import LatestArticles from './components/LatestArticles';
import FAQSection from './components/FAQSection';
import NewsletterSection from './components/NewsletterSection';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <FeaturesSection />
        <CategorySection />
        <LatestArticles />
        <FAQSection />
        <NewsletterSection />
      </main>
      <Footer />
      <ScrollToTop />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: '91网页版入口',
            url: 'https://91web.example.com/',
            description: '91网页版入口是您访问91平台最便捷的方式，无需下载客户端，打开浏览器即可直接进入。提供最新入口地址、访问教程及常见问题解答。',
            inLanguage: 'zh-CN',
            potentialAction: {
              '@type': 'SearchAction',
              target: 'https://91web.example.com/search?q={search_term_string}',
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: '91网页版入口',
            url: 'https://91web.example.com/',
            description: '91网页版入口官方直达通道，提供最新入口地址、访问教程及常见问题解答。',
            contactPoint: {
              '@type': 'ContactPoint',
              telephone: '400-000-9100',
              contactType: 'customer service',
              availableLanguage: 'Chinese',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '91网页版入口-官方直达通道',
            description: '91网页版入口是您访问91平台最便捷的方式，无需下载客户端，打开浏览器即可直接进入。',
            url: 'https://91web.example.com/',
            isPartOf: {
              '@type': 'WebSite',
              name: '91网页版入口',
              url: 'https://91web.example.com/',
            },
            primaryImageOfPage: {
              '@type': 'ImageObject',
              url: 'https://readdy.ai/api/search-image?query=Abstract%20geometric%20warm%20gradient%20background%20with%20flowing%20organic%20shapes&width=1800&height=1200&seq=hero-bg-91web&orientation=landscape',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: [
              {
                '@type': 'Question',
                name: '91网页版入口的最新地址是什么？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '您可以通过官方域名直接访问91网页版入口，或在搜索引擎中搜索"91网页版入口"找到官方认证结果。建议将正确地址加入浏览器收藏夹。',
                },
              },
              {
                '@type': 'Question',
                name: '91网页版无法打开怎么办？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '请依次尝试：清除浏览器缓存和Cookie、刷新DNS缓存、更换浏览器或更新至最新版本、检查网络连接。如果以上方法均无效，可能是服务器正在维护。',
                },
              },
              {
                '@type': 'Question',
                name: '91网页版需要下载安装吗？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '不需要。91网页版的最大优势就是无需下载任何客户端软件，您只需要使用浏览器打开入口地址即可直接使用。',
                },
              },
              {
                '@type': 'Question',
                name: '91网页版支持哪些浏览器？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '91网页版支持所有主流现代浏览器，包括Google Chrome、Microsoft Edge、Mozilla Firefox、Apple Safari、Opera等。建议使用最新版本。',
                },
              },
            ],
          }),
        }}
      />
    </>
  );
}